function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
    @external BaseClass
    @see https://github.com/d3plus/d3plus-common#BaseClass
*/
import { select } from "d3-selection";
import { accessor, BaseClass, constant, stylize } from "d3plus-common";
/**
    @class Button
    @extends external:BaseClass
    @desc Creates a set of HTML radio input elements.
*/

var Button =
/*#__PURE__*/
function (_BaseClass) {
  _inherits(Button, _BaseClass);

  /**
      @memberof Button
      @desc Invoked when creating a new class instance, and sets any default parameters.
      @private
  */
  function Button() {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this));
    _this._buttonStyle = {
      "font-family": "'Roboto', 'Helvetica Neue', 'HelveticaNeue', 'Helvetica', 'Arial', sans-serif",
      "font-size": "14px",
      "margin": "0 5px"
    };
    _this._data = [];
    _this._text = accessor("text");
    _this._value = accessor("value");
    return _this;
  }
  /**
      @memberof Button
      @desc Renders the element to the page.
      @chainable
  */


  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this._container === void 0) this.container(select("body").append("div").node());

      var container = this._container.selectAll("div#d3plus-Form-".concat(this._uuid)).data([0]);

      var svg = this._container.node().tagName.toLowerCase() === "foreignobject";
      container = container.enter().append(svg ? "xhtml:div" : "div").attr("id", "d3plus-Form-".concat(this._uuid)).attr("class", "d3plus-Form d3plus-Form-Button").merge(container);
      var button = container.selectAll("button").data(this._data, function (d, i) {
        return _this2._value(d, i);
      });
      button.exit().remove();
      button = button.enter().append("button").attr("class", "d3plus-Button").attr("type", "button").merge(button).call(stylize, this._buttonStyle).html(function (d, i) {
        return _this2._text(d, i);
      });

      for (var event in this._on) {
        if ({}.hasOwnProperty.call(this._on, event)) button.on(event, this._on[event]);
      }

      return this;
    }
    /**
        @memberof Button
        @desc Sets the css styles for the <input type="radio"> elements.
        @param {Object} [*value*]
        @chainable
    */

  }, {
    key: "buttonStyle",
    value: function buttonStyle(_) {
      return arguments.length ? (this._buttonStyle = _, this) : this._buttonStyle;
    }
    /**
        @memberof Button
        @desc If *selector* is specified, sets the SVG container element to the specified d3 selector or DOM element and returns the current class instance. If *selector* is not specified, returns the current SVG container element, which is `undefined` by default.
        @param {String|HTMLElement} [*selector*]
        @chainable
    */

  }, {
    key: "container",
    value: function container(_) {
      return arguments.length ? (this._container = select(_), this) : this._container;
    }
    /**
        @memberof Radio
        @desc Defines the array of values to be created as <button> tags. If no value is passed, the current array is returned.
        @param {Array} [*value* = []]
        @chainable
    */

  }, {
    key: "data",
    value: function data(_) {
      return arguments.length ? (this._data = _, this) : this._data;
    }
    /**
        @memberof Button
        @desc Sets the inner text for each <button> element.
        @param {Function|String} [*value* = function(d) { return d.text; }]
        @chainable
    */

  }, {
    key: "text",
    value: function text(_) {
      return arguments.length ? (this._text = typeof _ === "function" ? _ : constant(_), this) : this._text;
    }
    /**
        @memberof Button
        @desc Sets the value for each <button> element.
        @param {Function} [*value* = function(d) { return d.value; }]
        @chainable
    */

  }, {
    key: "value",
    value: function value(_) {
      return arguments.length ? (this._value = _, this) : this._value;
    }
  }]);

  return Button;
}(BaseClass);

export { Button as default };